import { render } from "./createItem.vue?vue&type=template&id=1d531294"
import script from "./createItem.vue?vue&type=script&lang=js"
export * from "./createItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__